import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { OpenInterestInitialStateType } from '../reducer/multiStrikeChart.reducer'

const state = (state: RootState) => state.multiStrikeChartStore as OpenInterestInitialStateType

export const selectMultiStrikeChartTimebucket = createDraftSafeSelector(state, (store) => store.timeBucket)
export const selectMultiStrikeChartSecurities = createDraftSafeSelector(state, (store) => store.securities)
export const selectMultiStrikeChartType = createDraftSafeSelector(state, (store) => store.chartType)
export const selectMultiStrikeCumOi = createDraftSafeSelector(state, (store) => store.cumOi)
export const selectMultiStrikeShowChange = createDraftSafeSelector(state, (store) => store.showChange)
export const selectMultiStrikeChartStyles = createDraftSafeSelector(state, (store) => store.styles)
export const selectMultiStrikeChartCallPut = createDraftSafeSelector(state, (store) => store.callPut)
export const selectMultiStrikeNearAtm = createDraftSafeSelector(state, (store) => store.nearAtm)
export const selectMultiStrikeAtm = createDraftSafeSelector(state, (store) => store.atm)
export const selectMultiStrikeLoading = createDraftSafeSelector(state, (store) => store.loading)
export const selectMultiStrikeKey = createDraftSafeSelector(state, (store) => store.key)